import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import PromotionsApp from 'bundles/promotions/components/PromotionsApp';

const PromotionsLandingPage = loadOnRoute(() => import('bundles/promotions/components/PromotionsLandingPage'));
const ApplyActiveSubscriptionDiscount = loadOnRoute(
  () => import('bundles/promotions/components/ApplyActiveSubscriptionDiscount')
);
const AbandonedCartPromotion = loadOnRoute(() => import('bundles/promotions/components/AbandonedCartPromotion'));
const Promotions404 = loadOnRoute(() => import('bundles/promotions/components/Promotions404'));

export default (
  <Route component={PromotionsApp} path="/promo">
    <Route path="activate" getComponent={ApplyActiveSubscriptionDiscount} />
    <Route path="create" getComponent={AbandonedCartPromotion} />
    <Route path=":promoCode" getComponent={PromotionsLandingPage} />
    <Route path="*" getComponent={Promotions404} />
  </Route>
);
